import * as React from "react";
import type { SVGProps } from "react";
const SvgCurrencyCoinYen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 17.28v-5.04m0 0L8.4 7.2m3.6 5.04 3.6-5.04m-6.48 8.64h5.76m-5.76-2.88h5.76M21.6 12a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 1 1 19.2 0"
    />
  </svg>
);
export default SvgCurrencyCoinYen;
